import { useQuery } from '@tanstack/react-query';
import { useNotification } from '../useNotification';
import { WebhookEventsListResponse } from '../../shared/types';
import { useFetchApi } from '../useFetchApi';

export const useWebhookSupportedEvents = () => {
  const fetch = useFetchApi();
  const { showErrorWithResponse } = useNotification();

  const events = useQuery({
    queryKey: ['webhooksEvents'],
    queryFn: () =>
      fetch('webhooks/events') as Promise<WebhookEventsListResponse>,
    onError: showErrorWithResponse,
    refetchOnWindowFocus: false,
  });

  return events;
};
